<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 18:43:36
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:10:38
 * @name: 权限管理
 * @Description: 权限管理
 * @FilePath: \preSaleNafterSaleBackstage\src\views\jurisdiction\role.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <layout-normal>
    <table-search-form title="角色列表">
      <template v-slot:searchForm>
        <div class="search-form">
          <div class="search-line">
            <div class="search-label">
              <font>角色名称</font>
            </div>
            <div class="search-content">
              <el-input
                size="mini"
                v-model="searchForm.role_name"
                placeholder="请输入角色名称"
                @blur="setFocus()"
                @keyup.native.enter="onQuery"
              ></el-input>
            </div>
          </div>
          <div class="btn-group">
            <el-button
              size="mini"
              icon="el-icon-search"
              type="primary"
              id="filterSearch"
              @keyup.enter="onQuery"
              @click="onQuery"
              >搜索</el-button
            >
            <el-button
              size="mini"
              icon="el-icon-refresh"
              plain
              @click="initData()"
              >刷新</el-button
            >
          </div>
        </div>
      </template>
      <template v-slot:head>
        <div class="head">
          <el-button size="mini" plain @click="addRole">添加角色</el-button>
        </div>
      </template>
      <template v-slot:table>
        <el-table
          :data="role_list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column align="center" prop="role_name" label="角色名称">
          </el-table-column>
          <el-table-column align="center" prop="create_time" label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="240"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="edit(scope.row)"
                >编辑</el-button
              ><font class="clip">|</font>
              <el-button size="mini" type="text" @click="del(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          class="pagination"
          v-if="pagination.page"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="total"
        >
        </Pagination>
      </template>
    </table-search-form>
    <role-edit-add
      ref="roleEditAdd"
      @saveSuccess="getTableData"
    ></role-edit-add>
  </layout-normal>
</template>
<script>
import tableSearchForm from "@/components/public/table-search-form.vue";
import roleEditAdd from "@/components/role/role-edit-add.vue";
import { confirmation, debounceation } from "@/utils/decorator";
import {
  adminRoleGetList,
  adminRoleDelete,
} from "@/api/admin_role/admin_role.api";
export default {
  name: "role",
  components: {
    tableSearchForm,
    roleEditAdd,
  },
  data() {
    return {
      searchForm: {
        role_name: "",
      },
      pagination: {}, //分页器信息
      role_list: [], //表格数据
      total: 0, //表格总行数
      loading: false, //加载中
    };
  },
  watch: {
    //分页数据发送变化查询表格数据
    pagination: {
      handler(nv, ov) {
        nv.page && this.getTableData();
      },
      immediate: false,
      deep: true,
    },
  },
  activated() {
    this.initData(); //初始化数据
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 置焦点于搜索框
     */
    setFocus() {
      document.getElementById("filterSearch").focus();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击搜索框
     */
    @debounceation(300)
    onQuery() {
      this.initPagination();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化数据
     */
    @debounceation(300)
    initData() {
      this.initSearchForm(); //初始化搜索条件表单
      this.initPagination(); //初始化分页信息
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化搜索条件表单
     */
    initSearchForm() {
      this.searchForm = {
        role_name: "",
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化分页信息
     */
    initPagination() {
      this.pagination = {
        page: 1,
        limit: 10,
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取表格数据
     */
    getTableData() {
      let params = { ...this.searchForm, ...this.pagination };
      this.loading = true;
      adminRoleGetList(params)
        .then((res) => {
          this.role_list = res.data?.data ?? [];
          this.total = res.data?.total ?? 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击添加角色
     */
    @debounceation(300)
    addRole() {
      this.$refs.roleEditAdd.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击编辑
     * @param {Object} row 产品行数据
     */
    @debounceation(300)
    edit(row) {
      this.$refs.roleEditAdd.open(row.id);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击删除
     * @param {Object} row 产品行数据
     */
    @confirmation("确认删除?")
    del(row) {
      adminRoleDelete({
        id: row.id,
      }).then(res => {
        this.getTableData();
      })
    },
  },
};
</script>
<style lang="scss" scoped>
</style>